import { Row, Space, Col, Menu, Dropdown, ConfigProvider, RadioChangeEvent, Tooltip, Table } from 'antd';
import { useEffect, useState } from 'react';
import { getBankAccount, getMachineInstallBill, finilizeMachineInstallRequest, newCableRequest, getLabList, getTemperatureRequestList, deleteTempratureRequest, makingTemperature, sendingTemperature, getLabTemperatureRequestList } from '../../api/api';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import type { ColumnsType } from 'antd/es/table';
import { useNavigate } from 'react-router-dom';
import { errorNotify, sucessNotify } from '../../services/toast.notification';
import { DownOutlined, DollarOutlined, DeleteOutlined, BuildOutlined, ToolOutlined, DeliveredProcedureOutlined } from '@ant-design/icons';
import { TemperatureOnlinePaymentdialog } from './TemperatureOnlinePaymentdialog';
import fa_IR from 'antd/lib/locale/fa_IR';
import { DatePicker as DatePickerJalali, JalaliLocaleListener , Calendar as CalendarJalali, useJalaliLocaleListener} from "antd-jalali";

import { UpdateLabList } from '../../redux/reducers/lablistSlice';
import { LabListContainer } from './style';
import { UpdateTemperatureInstallRequestList } from '../../redux/reducers/temperatureInstallRequestListSlice';
import TemperatureInstallTable from '../../components/_common/Table/temperatureInstallTable';
import { TemperatureManualPaymentDialog } from './temperatureManualPaymentDialog';


const TemperatureInstallRequest = () => {
    const [selectedLab, setSelectedLab] = useState(0);
    const [labList, setLabList] = useState<any[]>([]);
  
    const [selectedStatus, setSelectedStatus] = useState(-1);
    const myStore = useAppSelector((state) => state)
    const [statusList, setStatusList] = useState<any[]>([]);
    const [firstDate, setFirstDate] = useState<any>(undefined);
    const [lastDate, setLastDate] = useState<any>(undefined);
    const [value, setValue] = useState(0);
    var filterItem:any={};
    const [expandedRowRender]=useState([
        {title:'آزمایشگاه',val:'str_LabPersianName'}
        ,{title:'استان',val:'str_StateName'}
        ,{title:'دماسنج',val:'str_TemperatureName'}
        ,{title:'تعداد یخچال',val:'int_CountRefrigerator'}
        ,{title:'وضعیت',val:'str_Status'}
        ,{title:'تاریخ درخواست',val:'requestDate'}
        ,{title:'تایید مالی',val:'financialDate'}
        ,{title:'تاریخ ساخت',val:'finilizeDate'}
        ,{title:'سازنده',val:'manufacturerFullName'}
        ,{title:'تاریخ ارسال',val:'sendDate'}
        ,{title:'توضیحات درخواست',val:'str_Description'}
    ]);
    const columns: ColumnsType<any> = [
        
        {
            title: 'عملیات', 
            width: 70 , dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Dropdown overlay={menu(record)}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                            <DownOutlined />
                        </Space>
                    </a>
                </Dropdown>
            )
        },
        Table.EXPAND_COLUMN,
        { title: 'آزمایشگاه', dataIndex: 'str_LabPersianName', key: 'str_LabPersianName', width: 150},
       
        { title: 'استان', dataIndex: 'str_StateName', key: 'str_StateName' , width: 150},
        { title: 'دماسنج', dataIndex: 'str_TemperatureName', key: 'str_TemperatureName', width: 150, },
        { title: 'تعداد یخچال', dataIndex: 'int_CountRefrigerator', key: 'int_CountRefrigerator', width: 150 },
        { title: 'وضعیت', dataIndex: 'str_Status', key: 'str_Status' , width: 150},
        { title: 'تاریخ درخواست', dataIndex: 'requestDate', key: 'requestDate', width: 150 },
        { title: 'تایید مالی', dataIndex: 'financialDate', key: 'financialDate', width: 150 },
        { title: 'تاریخ ساخت', dataIndex: 'finilizeDate', key: 'finilizeDate' , width: 150 },
        {title:'سازنده',dataIndex:'manufacturerFullName', key: 'manufacturerFullName' , width: 150 },
        {title:'تاریخ ارسال',dataIndex:'sendDate', key: 'sendDate' , width: 150 },
        { title: 'توضیحات درخواست', 
        dataIndex: 'str_Description', key: 'str_Description'
        , width: 150
        , ellipsis: {
            showTitle: true,
          }
        , render: (str_Description) => (
            <Tooltip placement="topRight" title={str_Description}>
              {str_Description}
            </Tooltip>
          )
    },
   
];

    const menu = (record: any) => (
        <Menu
            items={[
                {
                    key: "1",
                    label:record.bit_Deleted? "بازیابی" : "حذف",
                    onClick: () => removeRequest(record.prk_TemperatureRequest_AutoID, record.bit_Deleted? false :true),
                    icon: <DeleteOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser') || !permission ,
                    danger: true
                },
                {
                    key: "2",
                    label: "پرداخت دستی",
                    onClick: () => manualPaymentOnClick(record.prk_TemperatureRequest_AutoID, record.str_TemperatureName,record.prk_ParsicLabBill_AutoID),
                    icon: <DollarOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser'  && record.int_Status < 4) || !permission

                },
                {
                    key: "3",
                    label: "ساخت",
                    onClick: () => makingTemperatureClick(record.prk_TemperatureRequest_AutoID,record.frk_FinancialApproveUserId),
                    icon: <BuildOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.int_Status == 2) || !permission

                },
                {
                    key: "4",
                    label: "ارسال",
                    onClick: () => sendingTemperatureClick(record.prk_TemperatureRequest_AutoID,record.frk_FinancialApproveUserId),
                    icon: <DeliveredProcedureOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.int_Status == 3) || !permission
                },
                {
                    key: "5",
                    label: "ثبت تعمیر",
                    // onClick: () => AssignInstaller(record.prk_MachineInstallRequest_AutoID),
                    icon: <ToolOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.int_Status == 4) || !permission
                },
            ]}
        />
    )


    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [showPaymentDialog, setShowPaymentDialog] = useState(false);
    const [showOnlinePaymentDialog, setShowOnlinePaymentDialog] = useState(false);

    const [paymentDialogPayload, setpaymentDialogPayload] = useState({ requestid: 0, temperatureName: "", bill: undefined, bankAccount: undefined });
    const [onlinePaymentDialogPayload, setOnlinepaymentDialogPayload] = useState({ requestid: 0, bill: undefined, onlinePaymentGateway: undefined });
    const [permission,setPermission] = useState(false);



    useEffect(() => {
        initFilter()
      

      if(myStore.auth.loginType=='labuser'){
        
        setSelectedLab(myStore.auth.userId?+myStore.auth.userId:0)
        setValue(2)
      }
     
        initStatusList()
        if (!myStore.labList.list) {
            loadLabs()
        }
        else {
            setLabList(myStore.labList.list);
            LabListInitilization(myStore.labList.list);
            loadTempratureInstallRequest(firstDate,lastDate);
        }
        if(myStore.auth.loginType === 'parsicuser')
        {
            myStore.auth.permission.map((item:any)=>{   
                if(item.pageName == 'temperatureInstallRequest')
                    setPermission(item.isDetailAccess);
            });
        }
        else
        {
            setPermission(true);
        }
    }, [])

   const initFilter=()=>{
    filterItem={}
    let strat=firstDate?firstDate.format('YYYY-MM-DD'):''
    let end=lastDate?lastDate.format('YYYY-MM-DD'):''
   
    filterItem.dateFrom= strat
    filterItem.dateTo= end
    filterItem.labId=myStore.auth.loginType=='labuser'? myStore.auth.userId?+myStore.auth.userId:0:0
    filterItem.searchMode= myStore.auth.loginType=='labuser'? 2:0
    filterItem.status=selectedStatus
    }
    const onChange = (e: RadioChangeEvent) => {
        
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
        console.log('value is',value)
        filterItem.searchMode= e.target.value
        filterItem.status=selectedStatus
        filterItem.labId=selectedLab
        let strat=firstDate?firstDate.format('YYYY-MM-DD'):''
        let end=lastDate?lastDate.format('YYYY-MM-DD'):''
        filterItem.dateFrom= strat
        filterItem.dateTo= end
        loadTempratureInstallRequest(firstDate,lastDate)

    };
    const initStatusList = () => {

        let model1: any = { val: -1, des: 'همه' }
        let model2: any = { val: 1, des: 'منتظر پرداخت' }
        let model3: any = { val: 2, des: 'منتظر پرداخت' }
        let model4: any = { val: 4, des: 'تهیه کابل' }
        let model5: any = { val: 6, des: 'درحال نصب' }
        let model6: any = { val: 10, des: 'تکمیل شده' }
        let data: any[] = []
        data.push(model1)
        data.push(model2)
        data.push(model3)
        data.push(model4)
        data.push(model5)
        data.push(model6)
        setStatusList(data)
    }
    const onChangeDatePicker = (dates: any, dateStrings: any, info: any) => {
        
        console.log(dates);
        if (!dateStrings) return;
        if (dateStrings.length < 2) return;
        if (dateStrings[0] === "") return;
        if (dateStrings[1] === "") return;

        setFirstDate(dates[0])
        setLastDate(dates[1])

        filterItem.searchMode= value
        filterItem.status=selectedStatus
        filterItem.labId=selectedLab
   
      
        filterItem.dateFrom= dateStrings[0]?dateStrings[0]:''
        filterItem.dateTo= dateStrings[1]?dateStrings[1]:''
        loadTempratureInstallRequest(dates[0],dates[1])
    }


//     const flatObject=()=>{
//         
//     let strat=firstDate?firstDate.format('YYYY-MM-DD'):''
//     let end=lastDate?lastDate.format('YYYY-MM-DD'):''
//     let filter:any={}
//     filter.labId= selectedLab
//     filter.dateFrom= strat
//     filter.dateTo= end
//     filter.searchMode= value
//     filter.status=selectedStatus
//     return filter
//    }
    const loadTempratureInstallRequest = (start?: any,end?:any) => {
        if(myStore.auth.loginType === "labuser")
        {
            getLabTemperatureRequestList(myStore.auth.userId?myStore.auth.userId:0)
            .then((result: any) => {
                result.data.data = result.data.data.map((item:any,i:any)=>{
                    item['index'] = i
                    return item
                })
                dispatch(UpdateTemperatureInstallRequestList({ temperatureInstallRequestList: result.data.data }))
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
        }
        else{
            getTemperatureRequestList(start?start.format('YYYY-MM-DD'):'',end?end.format('YYYY-MM-DD'):'')
            .then((result: any) => {
                result.data.data = result.data.data.map((item:any,i:any)=>{
                    item['index'] = i
                    return item
                })
                dispatch(UpdateTemperatureInstallRequestList({ temperatureInstallRequestList: result.data.data }))
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
        }
        

    }
    const loadLabs = () => {

        getLabList()
            .then((result: any) => {
                console.log(result.data.data);
                dispatch(UpdateLabList({ labList: result.data.data }))
                setLabList(myStore.labList.list);
                LabListInitilization(myStore.labList.list)
                // loadMachineInstallRequest();
                
                loadTempratureInstallRequest(firstDate,lastDate)
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }
    const LabListInitilization = (labItems: any) => {
        
        let allLabItem = { prk_AndriodLab_AutoID: 0, str_LabPersianName: "همه آزمایشگاه ها" }
        setLabList([allLabItem, ...labItems])
        setIsLoading(false)

    }
    const addNewOnClick = () => {
        myStore.auth.loginType === "labuser" ? navigate("/labuser/NewTemperatureInstallRequest") : navigate("/parsicuser/NewTemperatureInstallRequest")
    }


    const reCableRequest = (machineInstallRequestId: number) => {

        newCableRequest(machineInstallRequestId)
            .then((result: any) => {
                sucessNotify("اطلاعات با موفقیت ذخیره شده", undefined, 5000)
                // loadMachineInstallRequest();
                loadTempratureInstallRequest(firstDate,lastDate)
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const finilizeRequest = (id: number, labId: number, installerId?: number) => {

        finilizeMachineInstallRequest(id, labId, installerId)
            .then((result: any) => {
                sucessNotify("اطلاعات با موفقیت ذخیره شده", undefined, 5000)
                // loadMachineInstallRequest();
                loadTempratureInstallRequest(firstDate,lastDate)
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const manualPaymentOnClick = (id: number,temperatureName: string,billId:number) => {

        setShowPaymentDialog(true);

        setpaymentDialogPayload((values: any) => ({
            ...values,
            requestid: id,
            temperatureName: temperatureName,
            withASpecifiBill: true,
        }));


        getBankAccount()
            .then((result: any) => {

                setpaymentDialogPayload((values: any) => ({
                    ...values,
                    bankAccount: result.data.data,
                }));

            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })



        getMachineInstallBill(id,billId)
            .then((result: any) => {

                if (result.data.data.length > 0) {

                    setpaymentDialogPayload((values: any) => ({
                        ...values,
                        bill: result.data.data[0],
                    }));

                }

            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    // const onlinePayment = (id: number, machineName: string,billId:number) => {

    //     setShowOnlinePaymentDialog(true)

    //     setOnlinepaymentDialogPayload((values: any) => ({
    //         ...values,
    //         requestid: id,
    //     }));


    //     getMachineInstallBill(id,billId)
    //         .then((result: any) => {

    //             if (result.data.data.length > 0) {

    //                 setOnlinepaymentDialogPayload((values: any) => ({
    //                     ...values,
    //                     bill: result.data.data[0],
    //                 }));

    //             }

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //             errorNotify(error.response.data.errorMessage, undefined, 5000)
    //         })


    //     getOnlinePaymentGateway()
    //         .then((result: any) => {

    //             if (result.data.data.length > 0) {

    //                 setOnlinepaymentDialogPayload((values: any) => ({
    //                     ...values,
    //                     onlinePaymentGateway: result.data.data,
    //                 }));

    //             }

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //             errorNotify(error.response.data.errorMessage, undefined, 5000)
    //         })

    // }

    const makingTemperatureClick = (requestId:number,financialUserId:number) =>{
        setIsLoading(true);
        makingTemperature(requestId,Number(myStore.auth.userId),financialUserId)
        .then((result: any) => {
            sucessNotify("وضعیت دماسنج به حالت منتظر ارسال تغییر یافت.");
            loadTempratureInstallRequest(firstDate,lastDate);

         setIsLoading(false);
        })
        .catch((error) => {
            console.log(error);
            errorNotify(error.response.data.errorMessage, undefined, 5000)
        })
    }

    const sendingTemperatureClick = (requestId:number,financialUserId:number) =>{
        setIsLoading(true);
        sendingTemperature(requestId,Number(myStore.auth.userId),financialUserId)
        .then((result: any) => {
            sucessNotify("وضعیت دماسنج به حالت تحویل تغییر یافت.");
         loadTempratureInstallRequest(firstDate,lastDate);
         setIsLoading(false);

        })
        .catch((error) => {
            console.log(error);
            errorNotify(error.response.data.errorMessage, undefined, 5000)
        })
    }
    

    const removeRequest = (id: number,deleted:boolean) => {
        setIsLoading(true);
        deleteTempratureRequest(id,deleted)
        .then((result: any) => {
            loadTempratureInstallRequest(firstDate,lastDate)
            setIsLoading(false);
        })
        .catch((error) => {
            console.log(error);
            errorNotify(error.response.data.errorMessage, undefined, 5000)
        })
    }


    const onSubmitManualPayment=()=>{

    }
    // const AssignInstaller = (id: number) => {

    //     setShowAssignInstallerDialog(true)


    //     setAssignInstallerDialogPayload((values: any) => ({
    //         ...values,
    //         requestid: id,
    //     }));

    // }

    return (

        <>
         { isLoading === false &&(

        <LabListContainer>
        <Row justify="space-between" style={{textAlign:'right'}}>
         {/* <Col lg={7} md={12} sm={24} xs={24}>
             <label style={{fontSize:'10px'}}>فیلتر بر اساس :</label>
             <Radio.Group
             disabled={myStore.auth.loginType=='labuser'?true:false}
                 style={{ marginTop: '15px',display:'inline-block' }}
                 onChange={onChange} value={value}>
                     <Radio value={0}>همه</Radio>
                     <Radio value={1}> تاریخ </Radio>
                 <Radio value={2}> آزمایشگاه</Radio>
               
             </Radio.Group>
         </Col>
         <Col lg={7} md={12} sm={24} xs={24}>
             <CustomSelectAntDesign
                 name="status"
                 placeholder="وضعیت"
                 itemList={statusList}
                 value={( selectedStatus == -1) ? "همه  " : selectedStatus}
                 onChange={(val: any) => {
                    
                     setSelectedStatus(val);
                     filterItem.status=val
                     filterItem.labId=selectedLab
                     let strat=firstDate?firstDate.format('YYYY-MM-DD'):''
                     let end=lastDate?lastDate.format('YYYY-MM-DD'):''
                     filterItem.dateFrom= strat
                     filterItem.dateTo= end
                     filterItem.searchMode= value
                     loadTempratureInstallRequest()
                 }}
                 valueObjectField={"val"}
                 displayObjectField={"des"}
                 showSearch={true}
             />
         </Col>
         { value == 2 &&(
             <Col lg={7} md={12} sm={24} xs={24} >
             <CustomSelectAntDesign
                             name="lab"
                             placeholder="آزمایشگاه"
                             itemList={labList}
                             disabled={myStore.auth.loginType=='labuser'?true:false}
                             value={(selectedLab==0) ? "همه آزمایشگاه ها" : selectedLab}
                             onChange={(x: any) => {
                                filterItem.labId=x
                                let strat=firstDate?firstDate.format('YYYY-MM-DD'):''
                                let end=lastDate?lastDate.format('YYYY-MM-DD'):''
                                filterItem.dateFrom= strat
                                filterItem.dateTo= end
                                filterItem.searchMode= value
                                filterItem.status=selectedStatus
                                 setSelectedLab(x); loadTempratureInstallRequest() }}
                             valueObjectField={"prk_AndriodLab_AutoID"}
                             displayObjectField={"str_LabPersianName"}
                             showSearch={true}
                         />
              
             </Col>
         )}
       { value == 1&&( */}
   {myStore.auth.loginType !== "labuser" &&
    <Col lg={7} md={12} sm={24} xs={24}>
    <>
        <div
            style={{ marginTop: '4px' }}
            className="calender">
            <ConfigProvider locale={fa_IR} direction="rtl">
                <JalaliLocaleListener />
                <DatePickerJalali.RangePicker value={[firstDate, lastDate]} 
                onCalendarChange={(dates: any, dateStrings: any, info: any) =>
                onChangeDatePicker(dates, dateStrings, info)} />
            </ConfigProvider>
        </div>
    </>
    </Col>
}
       {/* )} */}
        
     </Row>
        </LabListContainer>
         )}
            <Row>
                <TemperatureInstallTable 
                columns={columns} 
                expandedRowRender={expandedRowRender}
                data={myStore.temperatureInstallRequestList.list} 
                isloading={isLoading} 
                onAddClick={addNewOnClick} 
                addButtonTitle={"درخواست نصب جدید"}
                permission={permission} />
            </Row>

            {showPaymentDialog && (
                <TemperatureManualPaymentDialog
                    visible={showPaymentDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => { setShowPaymentDialog(false); loadTempratureInstallRequest(firstDate,lastDate); }}
                    payLoad={paymentDialogPayload}
                    setShowDialog={(value) => setShowPaymentDialog(value)}
                />
            )}

            {showOnlinePaymentDialog && (
                <TemperatureOnlinePaymentdialog
                    visible={showOnlinePaymentDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => { setShowOnlinePaymentDialog(false);  loadTempratureInstallRequest(firstDate,lastDate); }}
                    payLoad={onlinePaymentDialogPayload}
                    setShowDialog={(value:any) => setShowOnlinePaymentDialog(value)}
                />
            )}


            {/* {showAssignInstallerDialog && (
                <AssignInstallerDialog
                    visible={showAssignInstallerDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => { setShowAssignInstallerDialog(false);  loadMachineInstallRequest(); }}
                    payLoad={assignInstallerDialogPayload}
                    setShowDialog={(value) => setShowAssignInstallerDialog(value)}
                />
            )} */}

        </>
    );
};

export default TemperatureInstallRequest